import React, { memo } from "react";
import { getPokemonFrameOffset } from "../logic/pokemon";
import "../styles/ShinyEffect.css";
import { POKEBALL_ITEM_ID, GREATBALL_ITEM_ID, ULTRABALL_ITEM_ID,
         LONGBALL_ITEM_ID, RANGEBALL_ITEM_ID, MUDBALL_ITEM_ID, RUBYBALL_ITEM_ID, SAPPHIREBALL_ITEM_ID, EMERALDBALL_ITEM_ID, GOLDENBALL_ITEM_ID, 
         DIAMONDBALL_ITEM_ID, SHADOWBALL_ITEM_ID,
         pokeballSprite, greatballSprite, ultraballSprite,
         longballSprite, rangeballSprite, mudballSprite, rubyballSprite,
          sapphireballSprite, emeraldballSprite, goldenballSprite, diamondballSprite, shadowballSprite } from "../../../constants/items";

const getBallSprite = (ballItemId) => {
  switch (ballItemId) {
    case POKEBALL_ITEM_ID:  return pokeballSprite;
    case GREATBALL_ITEM_ID: return greatballSprite;
    case ULTRABALL_ITEM_ID: return ultraballSprite;
    case LONGBALL_ITEM_ID:  return longballSprite;
    case RANGEBALL_ITEM_ID: return rangeballSprite;
    case MUDBALL_ITEM_ID: return mudballSprite;
    case RUBYBALL_ITEM_ID: return rubyballSprite;
    case SAPPHIREBALL_ITEM_ID: return sapphireballSprite;
    case EMERALDBALL_ITEM_ID: return emeraldballSprite;
    case GOLDENBALL_ITEM_ID: return goldenballSprite;
    case DIAMONDBALL_ITEM_ID: return diamondballSprite;
    case SHADOWBALL_ITEM_ID: return shadowballSprite;
    default: return pokeballSprite;
  }
};

export default memo(function PokemonLayer({
  pokemons, camX, camY, onPokemonClick, selectedBall
}) {
  return pokemons.map((p, i) => {
    const sx = p.x - camX, sy = p.y - camY;
    const style = {
      left: sx, top: sy,
      width: p.capturing ? 16 : 32,
      height: p.capturing ? 16 : 32,
      backgroundRepeat: "no-repeat",
      backgroundImage: `url(${p.capturing
        ? getBallSprite(p.usedBallItemId ?? POKEBALL_ITEM_ID)
        : p.sprite})`,
      backgroundPosition: p.capturing
        ? `-${(p.captureFrame||0)*16}px 0`
        : (() => {
            const { x, y } = getPokemonFrameOffset(p.direction,p.step);
            return `-${x}px -${y}px`;
          })(),
      backgroundSize: p.capturing ? "48px 16px" : undefined,
    };
    // Check special variant type by prefix in species name
    const getVariantType = (species) => {
      if (!species) return null;
      
      if (species.startsWith("Shiny")) return "shiny";
      if (species.startsWith("Shadow")) return "shadow";
      if (species.startsWith("Ruby")) return "ruby";
      if (species.startsWith("Sapphire")) return "sapphire";
      if (species.startsWith("Emerald")) return "emerald";
      if (species.startsWith("Golden")) return "golden";
      if (species.startsWith("Diamond")) return "diamond";
      
      return null;
    };
    
    const variantType = getVariantType(p.species);
    
    // Render special effects based on variant type
    const renderSpecialEffect = () => {
      if (p.capturing) return null; // Don't show effects during capture
      
      switch (variantType) {
        case "shiny":
          return (
            <div className="special-effect">
              <div className="shiny-spark"></div>
              <div className="shiny-spark"></div>
              <div className="shiny-spark"></div>
              <div className="shiny-spark"></div>
              <div className="shiny-spark"></div>
            </div>
          );
        case "shadow":
          return (
            <div className="special-effect">
              <div className="shadow-mist"></div>
              <div className="shadow-mist"></div>
              <div className="shadow-mist"></div>
              <div className="shadow-mist"></div>
              <div className="shadow-mist"></div>
            </div>
          );
        case "ruby":
          return (
            <div className="special-effect">
              <div className="ruby-crystal"></div>
              <div className="ruby-crystal"></div>
              <div className="ruby-crystal"></div>
              <div className="ruby-crystal"></div>
              <div className="ruby-crystal"></div>
            </div>
          );
        case "sapphire":
          return (
            <div className="special-effect">
              <div className="sapphire-crystal"></div>
              <div className="sapphire-crystal"></div>
              <div className="sapphire-crystal"></div>
              <div className="sapphire-crystal"></div>
              <div className="sapphire-crystal"></div>
            </div>
          );
        case "emerald":
          return (
            <div className="special-effect">
              <div className="emerald-crystal"></div>
              <div className="emerald-crystal"></div>
              <div className="emerald-crystal"></div>
              <div className="emerald-crystal"></div>
              <div className="emerald-crystal"></div>
            </div>
          );
        case "golden":
          return (
            <div className="special-effect">
              <div className="golden-particle"></div>
              <div className="golden-particle"></div>
              <div className="golden-particle"></div>
              <div className="golden-particle"></div>
              <div className="golden-particle"></div>
            </div>
          );
        case "diamond":
          return (
            <div className="special-effect">
              <div className="diamond-prism"></div>
              <div className="diamond-prism"></div>
              <div className="diamond-prism"></div>
              <div className="diamond-prism"></div>
              <div className="diamond-prism"></div>
            </div>
          );
        default:
          return null;
      }
    };
    
    return (
      <div
        key={`${p.id}-${i}`}
        className={`pokemon${p.capturing ? " shake" : ""}${variantType ? ` ${variantType}` : ""}`}
        style={style}
        onClick={() => onPokemonClick(p)}
      >
        {renderSpecialEffect()}
      </div>
    );
  });
})